// @flow
import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';

import config from 'app/config';


export const settingsKey: 'employeesOffice' = 'employeesOffice';

export type Settings = {
  rows: number,
  photo: boolean,
  fio: boolean,
  position: boolean,
  phone: boolean,
  email: boolean,
  ident: boolean,
}

const employeesOfficeDefaultState: Settings = {
  rows: config.perPageItems,
  photo: true,
  fio: true,
  position: true,
  phone: true,
  email: true,
  ident: true,
};

export default makeSettingsReducer(settingsKey, employeesOfficeDefaultState);
